import {
  PaymentMethod as PaymentMethodDto,
  Vehicle as VehicleDto,
} from './codegen/vehicles';
import {
  Transaction as TransactionDto,
  TransactionState,
} from './codegen/transactions';
import { Booking as BookingDto } from './codegen/bookings';
import { TreeGroup } from '@rio-cloud/rio-uikit/Tree';

export type PartialPick<T, F extends keyof T> = Omit<T, F> &
  Partial<Pick<T, F>>;

export type Transaction = TransactionDto & {
  vehicle?: Vehicle;
};

export const weaklyDisplayMonetaryAmounts = (
  transactionState: TransactionState,
) => {
  const weaklyDisplayStates = [
    TransactionState.Canceled,
    TransactionState.Failed,
  ];
  return weaklyDisplayStates.includes(transactionState);
};

export type Booking = BookingDto & {
  vehicle?: Vehicle;
};

export type PaymentMethod = Omit<PaymentMethodDto, 'expiry'> & {
  expiry?: string;
};

export type VehicleGroup = {
  id: string;
  name: string;
} & TreeGroup;

export type Vehicle = Omit<VehicleDto, 'paymentMethods'> & {
  paymentMethods: PaymentMethod[];
  groups: VehicleGroup[];
};

export enum BackendErrors {
  INVALID_FUEL_CARD = 'INVALID_FUEL_CARD',
  EXTERNAL_LOGIN_ERROR = 'EXTERNAL_LOGIN_ERROR',
  CARD_ALREADY_IN_USE_SAME_ACCOUNT = 'CARD_ALREADY_IN_USE_SAME_ACCOUNT',
  CARD_ALREADY_IN_USE_OTHER_ACCOUNT = 'CARD_ALREADY_IN_USE_OTHER_ACCOUNT',
}

export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}
